// XHR exposes real upload byte progress; reaching 100% is not a saved-photo ACK.
export function uploadProfilePhoto(file,{signal,onProgress=()=>{},onWaiting=()=>{}}={}){
 return new Promise((resolve,reject)=>{
  const xhr=new XMLHttpRequest();let settled=false;
  const finish=(error,result)=>{if(settled)return;settled=true;signal?.removeEventListener('abort',abort);error?reject(error):resolve(result);};
  const abort=()=>{xhr.abort();finish(new Error('photoUploadError'));};
  xhr.open('POST',`${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppyukle`);
  xhr.setRequestHeader('Authorization','Bearer '+localStorage.getItem('token'));
  xhr.timeout=180000;
  xhr.upload.onprogress=e=>onProgress(e.lengthComputable&&e.total>0?Math.max(0,Math.min(100,Math.floor(e.loaded/e.total*100))):null);
  xhr.upload.onload=()=>onWaiting();
  xhr.onload=()=>{
   let result;try{result=JSON.parse(xhr.responseText);}catch{}
   if(xhr.status<200||xhr.status>=300||result?.success!==true||!result?.url)return finish(new Error('photoUploadError'));
   finish(null,result);
  };
  xhr.onerror=xhr.ontimeout=xhr.onabort=()=>finish(new Error('photoUploadError'));
  if(signal?.aborted)return abort();
  signal?.addEventListener('abort',abort,{once:true});
  const data=new FormData();data.append('Foto',file);
  try{xhr.send(data);}catch{finish(new Error('photoUploadError'));}
 });
}
